import { useTranslation } from 'react-i18next';
import * as moment from 'moment';

export const useMomentLocale = () => {
  const { i18n } = useTranslation();
  const language = i18n.language;
  moment.locale(language);
};
